import useMounted from './use-mounted';

export default useMounted;
